import React, { FC } from 'react';
import { ConfigProvider, Pagination as AntdPagination, PaginationProps } from 'antd';
import fa_IR from 'antd/locale/fa_IR';

export const Pagination: FC<PaginationProps> = (props) => {
    return (
        <ConfigProvider
            locale={fa_IR}
        >
            <AntdPagination {...props} />
        </ConfigProvider>
    )
}